import { updateArea } from "../../../../../actions/Utilities/Area";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { editStateArea } from "../atoms/atoms";
import { useRecoilState } from "recoil";
import useSendEmail from "../../hooks/useSendEmail";

const useUpdateArea = () => {
  const queryClient = useQueryClient();
  const [, setActionEditState] = useRecoilState(editStateArea);
  const { mutateAsync: sendEmail } = useSendEmail();

  const { mutate } = useMutation((areaNewData) => updateArea(areaNewData), {
    onSuccess: (res) => {
      if (res === "Duplicate") {
        toast.fire(
          "Saving Failed",
          "Area Name or Area Code already exists!",
          "warning"
        );
      } else {
        queryClient.invalidateQueries(["GetArea"]);
        sendEmail(res.data, {
          onSuccess: (res) => {
            if (res) {
              if (res.status === 400) {
                toast.fire(
                  "Success",
                  "Area Updated Successfully, but failed in sending email",
                  "warning"
                );
              } else {
                toast.fire("Success", "Area Updated Successfully", "success");
              }
            }
          },
        });
        setActionEditState(false);
      }
    },
    onError: () => {
      toast.fire("Failed", "Failed to Update Area!", "error");
    },
  });
  return mutate;
};
export default useUpdateArea;
